import { ref } from "vue";
import { defineStore } from "pinia";

export const useAnimesStore = defineStore("animes", () => {
  const animes = ref([]);

  return { animes };
});
